/**
     *
     * Header mega menu toggle
     *
    */
   let $megaMenuToggle = $('[data-mega-menu-toggle]');
   let $megaMenuToggleLink = $megaMenuToggle.find('> a');
   $megaMenuToggle.on({
       mouseenter: function () {

           // Fix for IE that thinks it has hovered outside of a <li>,
           // when it hasn't /facepalm
           if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down) {
               $('[data-mega-menu]').addClass('hidden')
           }

           if ($('#predictive-search:visible').length > 0) {
            return;
           }

           // find the item, which is a <li>
           let $item = $(this)
           // Get the nearest mega menu
           let $megaMenuContainer = $item.find('[data-mega-menu]')
           // Show the mega menu
           $megaMenuContainer.removeClass('hidden')
           // Find all links and make it a different text colour
           $megaMenuToggleLink
            .addClass('opacity-50')
           // Find the link and make it a different text colour
           let $link = $item.find('> a');
           // Focus the current link
           $link
            .removeClass('opacity-50')
            .addClass('text-white');

       },
       mouseleave: function () {

           // Fix for IE bug that thinks it has hovered outside of a <li>
           if (theme.oldBrowsers.isIE11 || theme.oldBrowsers.isIE10Down)
               return false;

           // Reset all links
           $megaMenuToggleLink.removeClass('opacity-50')

           // Hide the panels
           $('[data-mega-menu]').addClass('hidden')

       }

   })